import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {}

  backClick() {
    this.router.navigateByUrl("/coach/account");
  }

  async contact(){
    this.router.navigateByUrl("/coach/contact");
  }

  async cgu(){
    this.router.navigateByUrl("/coach/cgu");
  }

  async cgv(){
    this.router.navigateByUrl("/coach/cgv");
  }

  async politique(){
    this.router.navigateByUrl("/coach/politique");
  }

  async mentions(){
    this.router.navigateByUrl("/coach/mentions");
  }
}
